<template>
  <BCard>
    <div class="text-black text-[20px] mb-2 font-[600] d-flex align-items-center">
      <img
        src="https://storage.googleapis.com/komerce/assets/icons/back.svg"
        alt="Komerce"
        class="cursor-pointer mx-1"
        @click="$router.back()"
      >
      History Subscription User
    </div>
    <BOverlay
      :show="loading"
      spinner-variant="primary"
      variant="light"
      blur="0"
      opacity=".5"
      rounded="sm"
    >
      <BTable
        id="scroll"
        ref="table-scroll"
        :items="listHistory"
        :fields="fieldHistoryUser"
        show-empty
        empty-text="Tidak ada data yang ditampilkan."
        responsive
        sticky-header="500px"
        class="mt-2"
        @scroll.native="handleScroll"
      >
        <template #cell(status)="data">
          <div class="d-flex flex-column">
            <div :class="getStatusClass(data.item.status.toLowerCase())" class="rounded text-center py-[5px] px-[1px] text-sm capitalize">
                {{ data.item.status }}
            </div>
          </div>
        </template>

        <template #cell(created_at)="data">
          <div class="flex-column min-w-[20px]">
            {{ formatDate(data.item.created_at) }}
          </div>
        </template>

        <template #cell(expired_date)="data">
          <div class="d-flex flex-column min-w-[20px]">
            {{ formatDate(data.item.expired_date) }}
          </div>
        </template>

        <template #cell(package)="data">
          <div class="d-flex align-items-center gap-5 flex-wrap">
            <img :src="packageIcon(data.item.package.toLowerCase())" alt="package" class="mr-[15px]">
            <li>
                {{ data.item.package_duration }} {{ getMonthLabel(data.item.package_duration) }}
            </li>
          </div>
        </template>

        <template #cell(amount)="data">
          <div class="d-flex align-items-center gap-5">
            {{ IDR(data.item.amount) }}
          </div>
        </template>

      </BTable>
    </BOverlay>
  </BCard>
</template>
<script>
import moment from 'moment'
import { openApiAxiosIns, collaboratorAxiosIns } from '@/libs/axios'
import { IDRWithoutLbl, IDR } from '@/libs/currency'
import { fieldHistoryUser } from '../config'

export default {
  data() {
    return {
      loading: false,
      userId: null,
      dataDetail: [],
      fieldHistoryUser,
      listHistory: [],
      IDRWithoutLbl,
      IDR,
      limit: 10,
      offset: 0,
      lastData: false,
    }
  },
  mounted() {
    const { id } = this.$router.history.current.params
    this.userId = id
    this.getHistory()
  },
  methods: {
    formatDate(d) {
      return moment(d).format('DD MMMM YYYY')
    },
    handleScroll(event) {
      const { scrollTop, scrollHeight, clientHeight } = event.target
      if (
        scrollTop + clientHeight >= scrollHeight - 1
        && !this.loading
        && !this.lastData
      ) {
        this.offset += 10
        this.getNextHistory()
      }
    },
    getHistory() {
      const params = {
        limit: this.limit,
        offset: this.offset,
      }
      this.loading = true
      const scrollContainer = this.$refs['table-scroll']?.$el
      openApiAxiosIns.get(`user/api/v1/admin/users/subscription/history/${this.userId}`, { params })
        .then(res => {
          this.listHistory = res.data.data

          if (scrollContainer) {
            scrollContainer.scrollTop = 0
          }

          this.lastData = this.listHistory.length < this.limit
        })
        .catch(err => {
          console.error(err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    getNextHistory() {
      if (!this.lastData) {
        const params = {
          limit: this.limit,
          offset: this.offset,
        }
        this.loading = true
        openApiAxiosIns.get(`user/api/v1/admin/users/subscription/history/${this.userId}`, { params })
          .then(res => {
            const newData = res.data.data
            this.listHistory = [...this.listHistory, ...newData]
            this.loading = false
            this.lastData = newData.length < this.limit || !newData
          })
          .catch(err => {
            console.error(err)
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    getMonthLabel(duration) {
      return duration <= 1 ? 'Month' : 'Months'
    },
    packageIcon(v) {
      if (v === 'enterprise') return 'https://storage.googleapis.com/komerce/rajaongkir/Label-enterprise.svg'
      if (v === 'pro') return 'https://storage.googleapis.com/komerce/rajaongkir/Label-pro.svg'
      return 'https://storage.googleapis.com/komerce/rajaongkir/Label-starter.svg'
    },
    getStatusClass(v) {
      if (v === 'success') return 'success'
      if (v === 'pending') return 'pending'
      return 'cancel'
    },
  },
}
</script>
<style scoped>
.success {
    background-color: #BEFCDE;
    color: #34A770;
    width: 100px;
}
.cancel {
    background-color: #FCBEBE;
    color: #E31A1A;
    width: 100px;
}
.pending {
    background-color: #FFF2E2;
    color: #FBA63C;
    width: 100px;
}
</style>
